import { Injectable } from '@angular/core';
import { LocationInterface } from 'app/models/location.model';
import { DataTransformAbstractGet } from 'app/modules/global/classes/data.transform.abstract.up';

@Injectable({
  providedIn: 'root',
})
export class LocationDataTransformGet extends DataTransformAbstractGet {
  transform(location: LocationInterface): LocationInterface {
    return location;
  }
}
